import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {IOSFullscreenModule} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {IOSFullscreenModuleStates} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class NotFullscreenState extends ModuleState<null, IOSFullscreenModule> {
    public onEnterState(): void {
        this.showScroll();
    }

    public onLeaveState(): void {
        this.hideScroll();
    }

    protected setupEvents(): void {
        this.setEventHandler('General.Screen.RESIZED', this.screenResized.bind(this));
        strictUiEmitter.on('UI.menu.opened', this.onStrictGotoIdleState.bind(this));
        this.setEventHandler('General.Popups.Add', this.hideScroll.bind(this));
        this.setEventHandler('General.Popups.AllPopupsHidden', this.showScroll.bind(this));
    }

    protected onStrictGotoIdleState(): void {
        if (this.module.currentState?.name === this.name) {
            this.gotoIdleState();
        }
    }

    protected screenResized(): void {
        if (this.module.isFullScreen()) {
            this.module.gotoState(IOSFullscreenModuleStates.Fullscreen);
        } else {
            this.showScroll();
        }
    }

    protected hideScroll(): void {
        this.module.hideScroll();
    }

    protected showScroll(): void {
        this.module.showScroll();
    }

    private gotoIdleState(): void {
        this.module.gotoState(IOSFullscreenModuleStates.Idle);
    }
}
